import { DataContext } from "@/types";
import { Data } from "../Data";
import { SettingsCourse } from "./SettingCourse";

export class SettingsCourseList extends Data {
  static instance: SettingsCourseList | null = null;
  static defaultPageSize = 50;

  courses: any;
  currentPage: any;
  totalPages: any;
  totalCount: any;
  hasNext: any;
  hasPrevious: any;

  constructor(options: any) {
    const { integrationId, facultyId, searchText, pageNumber, pageSize, orderBy, ...otherOptions } =
      options;
    const apiOptions = {
      api: `/Integration/Courses`,
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...otherOptions
    };

    // add params for api if provided
    const queryParams = [];
    if (integrationId) queryParams.push(`integrationId=${integrationId}`);
    if (facultyId) queryParams.push(`facultyId=${facultyId}`);
    if (searchText) queryParams.push(`searchText=${searchText}`);
    if (pageNumber) queryParams.push(`pageNumber=${pageNumber}`);
    if (pageSize) queryParams.push(`pageSize=${pageSize || SettingsCourseList.defaultPageSize}`);
    if (orderBy) queryParams.push(`orderBy=${orderBy}`);

    if (queryParams.length > 0) {
      apiOptions.api += `?${queryParams.join("&")}`;
    }

    super(apiOptions);

    this.courses = [];
    this.currentPage = 1;
    this.totalPages = null;
    this.totalCount = null;
    this.hasNext = false;
    this.hasPrevious = false;
  }

  onDataReceived(data: any) {
    // reformat data from api then assign to state
    const { currentPage, totalPages, totalCount, hasNext, hasPrevious } = data.courses;
    this.currentPage = currentPage;
    this.totalPages = totalPages;
    this.totalCount = totalCount;
    this.hasNext = hasNext;
    this.hasPrevious = hasPrevious;

    data.courses.data.forEach((c: any, index: any) => {
      const course = new SettingsCourse(c);
      this.courses.push(course);
    });
  }

  static getSettingCourseList(context: DataContext, updateCache: boolean): Promise<SettingsCourseList> {
    return new Promise((resolve, reject) => {
      if (SettingsCourseList.instance && updateCache !== true)
        resolve(SettingsCourseList.instance);
      else SettingsCourseList.instance = new SettingsCourseList({ resolve, reject, context });
    });
  }

  static getWithPaging(context: DataContext, options: any) {
    const { searchText, pageNumber, pageSize, orderBy, integrationId, facultyId } = options;

    return new Promise((resolve, reject) => {
      SettingsCourseList.instance = new SettingsCourseList({
        searchText,
        pageNumber,
        pageSize,
        orderBy,
        integrationId,
        facultyId,
        resolve,
        reject,
        context
      });
    });
  }
}
